<template>
    <div>
      <h4>Member registration</h4>
      <p></p>
      <div>
        <p></p>
        <h4>등록된 사용자</h4>
        <b-row>
          <b-col>
            <b-card>
              <b-table striped bordered id="my-table3" :items="companyItems" :fields="companyFields"
                  @row-clicked="myRowClickHandler" hover responsive>
                </b-table>
  
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <b-table striped bordered id="my-table" :items="items" :fields="fields"
                   hover responsive>
                </b-table>
  
            </b-card>
          </b-col>
        </b-row>
      </div>
      <p></p>
    </div>
  
  </template>
  <script>
  
//   import FacilityDetailsVue from './FacilityDetails.vue';
  
import hal from 'hateoas-hal-link-resolver'
  export default {
    components: {
    //   FacilityDetailsVue
    },
    created() {
      
    },
    async mounted() {
        console.log('mount ====== >')
        await this.search();

    },
    async beforeMount() {
    //   this.company = await this.$getOrganization();
    },
    data() {
      return {
        items: [],
        companyItems: [],
        fields: [
         { key: 'id', label: '아이디', class: 'text-center' },
          { key: 'name', label: '이름', class: 'text-center' },
        ],
        companyFields: [
         { key: 'id', label: '아이디', class: 'text-center' },
          { key: 'name', label: '회사명', class: 'text-center' },
        ]
      }
    },
    methods: {

       async search(){
        const response = await this.$http.get(`http://localhost:8080/api/CRUDCompany`);
        console.log(response)
        this.companyItems = response.data._embedded.CRUDCompany;
        },
        async myRowClickHandler(record){  
            // console.log('myRowClickHandler -> ', record);
            const url = hal(record, 'members');
            console.log(url);
            const response = await this.$http.get(url);
            this.items = response.data._embedded.CRUDMember;
        }
    },
    computed: {
      rows() {
        // console.log(this.items.length)
        return this.items.length
      }
    },
    watch: {
    }
  }
  </script>